import React from "react"

class SeasonalPricePresenter extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var days_of_week = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    var days = days_of_week.map((day_of_week) => this.renderDayOfWeek(day_of_week))
    var override = days_of_week.map((day_of_week) => this.renderDailyAmount(day_of_week))
    var original = days_of_week.map((day_of_week) => this.renderBasePrice(day_of_week))
    var min_stay = days_of_week.map((day_of_week) => this.renderDailyMinimumStay(day_of_week))

    return (
      <div className="seasonal-price">
        <div className="row" style={{marginBottom: 20}}>
          { this.renderRoomType() }
        </div>
        <div className="container-fluid" style={{overflowX: "scroll"}}>
          <div className='row' style={{minWidth: "800px"}}>
            <div className='col-md-2 col-sm-2 col-xs-2' style={{width: '12%', marginRight: "20px"}}>
              <label style={{visibility:"hidden"}}>""</label>
            </div>
            {days}
          </div>
          <div className='row' style={{marginTop: "10px", minWidth: "800px"}}>
            <div className='col-md-2 col-sm-2 col-xs-2' style={{width: '12%', marginRight: "20px"}}>
              <label>{I18n.t("override")}</label>
            </div>
            {override}
          </div>
          <div className='row' style={{marginTop: "10px", minWidth: "800px"}}>
            <div className='col-md-2 col-sm-2 col-xs-2' style={{width: '12%', marginRight: "20px"}}>
              <label>{I18n.t("original")}</label>
            </div>
            {original}
          </div>
          { this.props.view_type === 'group_contract_price'
              ? ''
              : <div className='row' style={{marginTop: "10px", minWidth: "800px"}}>
                  <div className='col-md-2 col-sm-2 col-xs-2' style={{width: '12%', marginRight: "20px"}}>
                    <label style={{whiteSpace:'nowrap'}}>{I18n.t("minimum_stay")}</label>
                  </div>
                  {min_stay}
                </div>
          }
        </div>
      </div>
    )
  }

  renderRoomType() {
    if (this.props.view_type === 'room_type_price' || this.props.view_type === 'group_contract_price') {
      return (
        <div>
          <div className="col-md-10">
            <label>{I18n.t('room_type')}</label>
            <div>{this.props.room_type.name}</div>
          </div>
        </div>
      )
    }
  }

  renderDayOfWeek(day_of_week) {
    return (
      <div className='col-sm' style={{width: '12%'}} key={day_of_week}>
          <label>{I18n.t(day_of_week)}</label>
      </div>
    )
  }

  renderDailyAmount(day_of_week) {
    var name = day_of_week + '_amount';
    return (
      <div className='col-sm' style={{width: '12%'}} key={name}>
        <div>{this.props[name] ? '$' + (this.props[name] / 100) : null}</div>
      </div>
    )
  }

  renderDailyMinimumStay(day_of_week) {
    var min_stay_name = day_of_week + '_minimum_stay';
    return (
      <div className='col-sm' style={{width: '12%'}} key={min_stay_name}>
        <div>{this.props[min_stay_name] ? <span>{this.props[min_stay_name]} {I18n.t('nights')}</span> : null}</div>
      </div>
    )
  }

  renderBasePrice(day_of_week) {
    var base_price = day_of_week + '_amount';
    return (
      <div className='col-sm' style={{width: '12%'}} key={base_price}>
        <div>{ this.props.room_type_price ? <span> <em>{I18n.t('number.currency.format.unit')}{this.props.room_type_price[base_price]/100}</em></span> : null}</div>
      </div>
    )
  }

}

export default SeasonalPricePresenter